import { render } from "./DashboardRank.vue?vue&type=template&id=ecae74bc"
import script from "./DashboardRank.vue?vue&type=script&lang=js"
export * from "./DashboardRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__